import http from '@/http-common';

class NotificationService{

    getNotification() { 
        return http.get(`/get-notification`);
    }
    updateread(id){
        return http.get(`${id}/update/read/notification`)

    }
    getNotificationAll(){
        return http.get(`/get-notification-all`);
    }

    
 

}

export default new NotificationService();

